<span class="uds-svg" [inlineSVG]="src" [ngClass]="{'disabled': disabled}" [setSVGAttributes]="{width: w, height: h}"
  (click)="clicked($event)"></span>